/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { ref, set, onValue, query, orderByChild } from "firebase/database";
import StartFirebase, { auth } from "../services/firebaseConfig";
import { Row, Col, Container, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { onAuthStateChanged } from '@firebase/auth';
import Leaderboard from '../components/Leaderboard';
import YTDLeaderboard from '../components/YTDLeaderboard';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TextLinkExample from '../components/Navbar';
import Moment from 'moment';

const CurrentWeek = () => {
    const [games, setGames] = useState([]);
    const [allGames, setAllGames] = useState([]);
    const db = StartFirebase();
    const [weekNum, setWeekNum] = useState('0');
    const [closed, setClosed] = useState(false);
    const settingsRef = ref(db, '/settings/');
    const userRef = ref(db, '/users/');
    const dbRef = ref(db, '/games/week/' + weekNum + '/');
    const allGamesRef = ref(db, '/games/week/');
    const allPickRef = ref(db, '/picks/');
    const gameQuery = query(dbRef, orderByChild('kickoff'));
    const allGamesQuery = query(allGamesRef, orderByChild('kickoff'));
    const [totalGameCount, setTotalGameCount] = useState();
    const [selectedPicks, setSelectedPicks] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedConfidence, setSelectedConfidence] = useState([]);
    const [kickoffDate, setKickOffDate] = useState("");
    const [allPicks, setAllPicks] = useState([]);
    const [dataChanged, setDataChanged] = useState(false);
    const [incomplete, setIncomplete] = useState(false);
    const [user, setUser] = useState({});
    const [validateDatabase, setValidateDatabase] = useState(0);
    Moment.locale('en');
    //test
    const updateSelectedConfidence = (value) => {
        var tempArray;
        if (selectedConfidence.indexOf(value) <= -1) {
            tempArray = [...selectedConfidence, value];
        }
        else {
            tempArray = selectedConfidence.filter(items => items === value);
        }
        setSelectedConfidence(tempArray);
    }

    const handleToggle = (type, id, value) => {
        try {
            setDataChanged(true);
            if (user.uid === undefined) { alert('You must log in first.') }
            const tempPick = selectedPicks.filter(picks => picks.key === id);
            if (tempPick.length > 0) {
                const tempArray = selectedPicks.map(obj => {
                    if (obj.key === id) {
                        return { ...obj, [type]: value }
                    }
                    return obj;
                })
                setSelectedPicks(tempArray);
            }
            else {
                var tempArray = [];
                tempArray = ({ "key": id, "pick": -1, "ou": -1, "confidence": -1 });
                tempArray = { ...tempArray, [type]: value }
                const newPicks = selectedPicks.map(obj => { return obj; });
                newPicks.push(tempArray);
                /*if (type === 'pick') { newPicks.push({ "key": id, "pick": value, "ou": -1, "confidence": -1 }); }
                else if (type === 'ou') { newPicks.push({ "key": id, "pick": -1, "ou": value, "confidence": -1 }); }
                else if (type === 'confidence') { updateSelectedConfidence(value); newPicks.push({ "key": id, "pick": -1, "ou": -1, "confidence": value }); }*/
                setSelectedPicks(newPicks);

            }
        } catch (e) {
            //console.log(e.message);
        }
    }
    
    const insertData = () => {
        if (dataChanged) {
            if (selectedPicks.length > 0) {
                selectedPicks.map((doc) => {
                    return set(ref(db, '/picks/' + user.uid + '/week/' + weekNum + '/' + doc.key), { "pick": doc.pick, "ou": doc.ou, "confidence": doc.confidence });
                })
            }
        }
        setDataChanged(false);
    }

    /**
 * if db, weekNum or user.id changes
 * update selectedPicks and selectedList with data from the get picks for user and weekNum
 * 
 */
    const getSelectedPicks = () => {
        //console.log("getSelected ran");
        if (weekNum > 0 && user.uid !== undefined) {
            const pickRef = ref(db, '/picks/' + user.uid + '/week/' + weekNum + '/');
            var missingPick = false;
            onValue(pickRef, (snapshot) => {
                let pickRecords = [];
                let tempList = [];
                let tempConf = [];
                snapshot.forEach(childsnapshot => {
                    let keyName = childsnapshot.key;
                    let pick = childsnapshot.val().pick;
                    let ou = childsnapshot.val().ou;
                    let confidence = childsnapshot.val().confidence;
                    if (pick.toString() === "-1" || ou.toString() === "-1" || confidence.toString() === "-1") {
                        missingPick = true;
                    }

                    tempList.push(childsnapshot.key + 'pick' + pick);
                    tempList.push(childsnapshot.key + 'ou' + ou);
                    tempList.push(childsnapshot.key + 'confidence' + confidence);
                    tempConf.push(confidence);
                    pickRecords.push({ "key": keyName, "pick": pick, "ou": ou, "confidence": confidence })
                });
                if (pickRecords.length < 10 && pickRecords.length > 0) {
                    missingPick = true;
                }
                //setSelectedPicksDB(pickRecords);
                setIncomplete(missingPick);
                setSelectedPicks(pickRecords);
                setSelectedList(tempList);
                setSelectedConfidence(tempConf);
            });
        }
    };


 /**1
 * when page loads
 * update the weekNum and closed variable with data from the get settings query.
 * update the allGame variable with data from the get all games query.
 * update the allUsers variable with data from the get all user query.
 */
    useEffect(() => {
        //console.log('useEffect 1 ran');
        onValue(settingsRef, (snapshot) => {
            try {
                setWeekNum(snapshot.val().currentWeek.toString());
                setClosed(snapshot.val().picksClosed);
            } catch (e) { console.log(`the following useEffect/settingsRef occured: ${e.message}`) }
        });

        onValue(allGamesQuery, (snapshot) => {
            let tempGames = [];
            snapshot.forEach(childsnapshot => {
                childsnapshot.forEach(moreChildSnapshot => {
                    tempGames.push({ "key": moreChildSnapshot.key, "data": moreChildSnapshot.val() });
                })
            });
            setAllGames(tempGames);
        })

        onValue(userRef, (snapshot) => {
            let teamAllUsers = [];
            snapshot.forEach(childsnapshot => {
                teamAllUsers.push({ "key": childsnapshot.key, "data": childsnapshot.val() });
            });
            setAllUsers(teamAllUsers);
        })
        //getSelectedPicks();

        onValue(gameQuery, (snapshot) => {
            let records = [];
            let tempCount = 0;
            snapshot.forEach(childsnapshot => {
                let keyName = childsnapshot.key;
                let data = childsnapshot.val();
                tempCount++;
                records.push({ "key": keyName, "data": data });
            });
            setTotalGameCount(tempCount);
            setGames(records);
            if (records.length > 0) {
                setKickOffDate(records[0].data.kickoff);
            }
        });

        onValue(allPickRef, (snapshot) => {
            let tempPickList = [];
            snapshot.forEach(childsnapshot => {
                var tempData = childsnapshot.val(); //.week[weekNum];
                if (tempData !== undefined) {
                    tempPickList.push({ "key": childsnapshot.key, "data": tempData })//childsnapshot.val().week[weekNum] })
                }
            });
            setAllPicks(tempPickList);
        })

    }, [weekNum]);

    /**2
     * when selected picks change
     * run insertData function.
     */
    useEffect(() => {
        //console.log('useEffect 2 ran');
        //var missingPickIndex = JSON.stringify(selectedPicks).indexOf(-1).toString();
        //var pickCount = selectedPicks.length;
        if (dataChanged) {
            if (user.uid !== undefined) {
                insertData();
            }
            setValidateDatabase(validateDatabase + 1);
        }
        /*if (missingPickIndex === '-1' && pickCount === 10) {
            setIncomplete(false);
        }
        else if (missingPickIndex !== '-1' && pickCount > 0) {
            setIncomplete(true);
        }*/
    }, [selectedPicks]);

    /**3
     * when week number changes :
     *  - update the 'records' data by getting all games for the 'weekNum'.
     *  - update the 'allPicks' by getting all picks for every week.
     *  - run getSelectedPicks()
     * 
     * 
    useEffect(() => {
        console.log('useEffect 3 ran');
        if (weekNum > 0) {
            onValue(gameQuery, (snapshot) => {
                let records = [];
                let tempCount = 0;
                snapshot.forEach(childsnapshot => {
                    let keyName = childsnapshot.key;
                    let data = childsnapshot.val();
                    tempCount++;
                    records.push({ "key": keyName, "data": data });
                });
                setTotalGameCount(tempCount);
                setGames(records);
                if (records.length > 0) {
                    setKickOffDate(records[0].data.kickoff);
                }
            });

            onValue(allPickRef, (snapshot) => {
                let tempPickList = [];
                snapshot.forEach(childsnapshot => {
                    var tempData = childsnapshot.val(); //.week[weekNum];
                    if (tempData !== undefined) {
                        tempPickList.push({ "key": childsnapshot.key, "data": tempData })//childsnapshot.val().week[weekNum] })
                    }
                });
                setAllPicks(tempPickList);
            })

            onAuthStateChanged(auth, (currentUser) => {
                if (!currentUser) {
                   // setUser({});
                }
                else {
                    //setUser(currentUser);
                }
            });
            //getSelectedPicks();
        }
    }, [weekNum]);*/

    /**4
     * when user changes
     *  - update the selectedPicks data by get all the picks for the current user and weekNum.
     *  - update the selectedList data by getting all the picks for the current user and weekNum.
     *  - update the selectedConfidence data by getting all the picks for the current user and weekNum.
     */
    useEffect(() => {
        //console.log('useEffect 4 ran');
        if (weekNum > 0 && user.uid !== undefined) {
            const pickRef = ref(db, '/picks/' + user.uid + '/week/' + weekNum + '/');
            var missingPick = false;
            onValue(pickRef, (snapshot) => {
                let pickRecords = [];
                let tempList = [];
                let tempConf = [];
                snapshot.forEach(childsnapshot => {
                    let keyName = childsnapshot.key;
                    let pick = childsnapshot.val().pick;
                    let ou = childsnapshot.val().ou;
                    let confidence = childsnapshot.val().confidence;
                    if (pick.toString() === "-1" || ou.toString() === "-1" || confidence.toString() === "-1") {
                        missingPick = true;
                    }

                    tempList.push(childsnapshot.key + 'pick' + pick);
                    tempList.push(childsnapshot.key + 'ou' + ou);
                    tempList.push(childsnapshot.key + 'confidence' + confidence);
                    tempConf.push(confidence);
                    pickRecords.push({ "key": keyName, "pick": pick, "ou": ou, "confidence": confidence })
                }); 
                if (pickRecords.length < 10 && pickRecords.length > 0) {
                    missingPick = true;
                }
                //setSelectedPicksDB(pickRecords);
                setIncomplete(missingPick);
                missingPick = false;
                setSelectedPicks(pickRecords);
                setSelectedList(tempList);
                setSelectedConfidence(tempConf);
            });
        }
    }, [user, validateDatabase, weekNum]);

    return (
        <>
            <div className="outerDiv" style={{ margin: 'auto', width: '100vw' }}>
                <TextLinkExample getUser={setUser} database={db} />
            <div>
                <img className="mainHeader" src={require('../images/masthead_new.png')} alt="College Football Pick 'Em" />
                <br />
            </div>
                <div className="whiteText" style={{ textAlign: 'center' }}>
                    {closed ? (<h4>Picks are closed.</h4>) : (<><h4 style={{ color: "#cdcdcd" }}>Picks close on<br /><h3 style={{ color: "#ffffff"}}>{Moment(new Date(kickoffDate)).format('dddd MMM DD')} at {new Date(kickoffDate).toLocaleTimeString()}</h3></h4><p style={{ color: "#ababab", fontStyle:"italic" } }>Picks will automatically save as you make your selections.</p></>)}
                </div>
                <Container>
                    <Row>
                        <Col xxl={{ order: 'last' }}>
                            <Tabs
                                defaultActiveKey="weekly"
                                id="justify-tab-example"
                                className="leaderboardTabs"
                                justify>
                                <Tab eventKey="weekly" title={"Week " + weekNum}>
                                    <Leaderboard allUsers={allUsers} allPicks={allPicks} allGames={games} weekNum={weekNum} />
                                </Tab>
                                <Tab eventKey="ytd" title="Year To Date">
                                    <YTDLeaderboard allUsers={allUsers} allPicks={allPicks} allGames={allGames} weekNum={weekNum} />
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col xs='12' xxl='8'>
                            <div className="whiteText centerAlign">
                                    {<div className="centerAlign neutralTag">* denotes neutral site</div>}
                                    {selectedPicks.length > 0 ? incomplete ? <div className="validationAlertIncomplete">Picks are not complete. <img src={'alert.png'} alt="Alert" /></div> : <div className="validationAlertComplete">Picks are complete.<img src={'checkmark.png'} alt="Checkmark" /></div> : null}
                                {games.map(function (doc, index) {
                                    var selectedConf = -1;
                                    if (selectedPicks.filter(pick => pick.key === doc.key).map(data => data.confidence)[0] > 0) {
                                        selectedConf = selectedPicks.filter(pick => pick.key === doc.key).map(data => data.confidence)[0];
                                    }                                    
                                    return <div key={doc.key}>
                                        <Container className="picksContainer">
                                            <Row className="pickRow">
                                                <Col xs='2' xxl='2' className="rowNum" style={{ textAlign: 'center' }}>
                                                    {index + 1}
                                                    {/*<img src={doc.data.logo} width="60"/>*/}
                                                </Col>
                                                <Col className="leftAlign">
                                                    <ToggleButtonGroup name="pick" type="checkbox">
                                                        <table className="pickTable"><tbody>
                                                            <tr>
                                                                <td>
                                                                    <ToggleButton
                                                                        disabled={closed}
                                                                        value="0"
                                                                        className={selectedList.indexOf(doc.key + 'pick' + 0) >= 0 ? "selected pickButton buttonTop" : "pickButton buttonTop"}
                                                                        type="checkbox"
                                                                        selected={selectedList.indexOf(doc.key + 'pick' + 0) >= 0}
                                                                        id={doc.key + 0}
                                                                        name={doc.key}
                                                                        onChange={(e) => handleToggle('pick', e.currentTarget.name, e.currentTarget.value)}>
                                                                        {doc.data.awayTeam}&nbsp;&nbsp;&nbsp;{+doc.data.favorite === 0 ? '-' : '+'}{doc.data.spread}
                                                                        {+doc.data.neutralSite === 1 ? ' *' : ''}
                                                                    </ToggleButton>
                                                                </td>
                                                                <td>
                                                                    <div className="score">&nbsp;{doc.data.awayScore}</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <ToggleButton
                                                                        disabled={closed}
                                                                        value="1"
                                                                        className={selectedList.indexOf(doc.key + 'pick' + 1) >= 0 ? "pickButton buttonBottom selected" : "pickButton buttonBottom"}
                                                                        type="checkbox"
                                                                        id={doc.key + 1}
                                                                        selected={selectedList.indexOf(doc.key + 'pick' + 0) >= 1}
                                                                        name={doc.key}
                                                                        onChange={(e) => handleToggle('pick', e.currentTarget.name, e.currentTarget.value)}>
                                                                        {doc.data.homeTeam}&nbsp;&nbsp;&nbsp;{+doc.data.favorite === 1 ? '-' : '+'}{doc.data.spread}
                                                                        {+doc.data.neutralSite === 1 ? ' *' : ''} </ToggleButton>
                                                                </td>
                                                                <td>
                                                                    <div className="score">&nbsp;{doc.data.homeScore}</div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        </table>
                                                    </ToggleButtonGroup>
                                                </Col>
                                                <Col className="centerAlign">
                                                    <ToggleButtonGroup name="ou">
                                                        <table className="overUnderTable"><tbody>
                                                            <tr>
                                                                <td>
                                                                    <ToggleButton disabled={closed} value="0" className={selectedList.indexOf(doc.key + 'ou' + 0) >= 0 ? "overUnderButton selected buttonTop" : "overUnderButton buttonTop"} type="checkbox" selected={selectedList.indexOf(doc.key + 'ou' + 0) >= 0} id={doc.key + 2} name={doc.key} onChange={(e) => handleToggle('ou', e.currentTarget.name, e.currentTarget.value)}>OVER</ToggleButton>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <div className="overUnderLabel centerText whiteText">{doc.data.overUnder}</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <ToggleButton disabled={closed} value="1" className={selectedList.indexOf(doc.key + 'ou' + 1) >= 0 ? "overUnderButton selected buttonBottom" : "overUnderButton buttonBottom"} type="checkbox" selected={selectedList.indexOf(doc.key + 'ou' + 1) >= 0} id={doc.key + 3} name={doc.key} onChange={(e) => handleToggle('ou', e.currentTarget.name, e.currentTarget.value)} >UNDER</ToggleButton>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        </table>
                                                    </ToggleButtonGroup>
                                                </Col>
                                                <Col xs='2' xxl='' className="centerAlign">
                                                    <div className="confidenceHeader">Confidence</div>
                                                    <select disabled={closed} id={`dropdown-basic-button${doc.key}`} className="confidenceDropDown" title="Confidence" multiple={false} key={doc.key + 4} name={doc.key} value={selectedConf} onChange={(e) => handleToggle('confidence', e.currentTarget.name, e.currentTarget.value)}>
                                                        <option value="-1" key="-1">-</option>
                                                        {Array.from(Array(totalGameCount + 1), (e, i) => {
                                                            if (i > 0) {
                                                                return <option disabled={selectedConfidence.indexOf(i.toString()) >= 0} value={i} key={i} >{i}</option>
                                                            }
                                                        })}
                                                    </select >
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>;
                                })}
                                </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
    /*    
    //const handleClose = () => setShow(false);
    //const handleShow = () => setShow(true);
    //const [userEmail, setUserEmail] = useState('');
    //const [userPassword, setUserPassword] = useState('');
    //const [settings, setSettings] = useState([]);
    //const [show, setShow] = useState(false);
    //const [value, setValue] = useState(0, 1);
    //const [selectedPicksDB, setSelectedPicksDB] = useState();
    //const [allGames, setAllGames] = useState([]); //useEffect(() => { getAllGames(); }, []);

    const login = async () => {
        try {
            await signInWithEmailAndPassword(
                auth,
                userEmail,
                userPassword
            ).then((userCredential) => {
                //setUser(userCredential.user);
            });
        } catch (error) {
            if (error.code.toString().indexOf("invalid-email") !== -1){
                alert('Email address is currently not registered.');
            }
            if (error.code.toString().indexOf("wrong-password") !== -1) {
                alert('Password does not match our records.');
            }
            if (error.code.toString().indexOf("too-many-requests") !== -1) {
                alert('This account has been has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.');
            }
            if (error.code.toString().indexOf("user-not-found") !== -1) {
                alert('Email address is currently not registered.');
            }
            console.log(error.code + ":" + error.message);
        }
    }
    
       const register = async () => {
        setShow(true);
    }
    
    const resetPass = async () => {
        try {
            await sendPasswordResetEmail(auth, userEmail).then(() => {
                alert('Check your inbox for an email from noreply@pickem - 3a187.firebaseapp.com to reset your password.')
            });
        } catch (error) {
            if (error.code.toString().indexOf("missing-email") !== -1) {
                alert('Enter your email address first, then select reset password');
            }
            if (error.code.toString().indexOf("invalid-email") !== -1) {
                alert('Email is not vaild.');
            }
            if (error.code.toString().indexOf("user-not-found") !== -1) {
                alert('Email address is currently not registered.');
            }
            console.log(error.code);
        }
    }

    const logout = async () => {
        await signOut(auth);
        setUserEmail("");
        setUserPassword("");
        
        const setSelected = (value) => { console.log(value); }
    }

    function isItemInArray(array, item) {
        let check = false;
        for (var i = 0; i < array.length; i++) {
            // This if statement depends on the format of your array
            array.map((doc) => {
                if (doc.key === item) {
                    check = doc.key === item;
                }
                else {
                    check = false;   // Not found
                }
            })
            return check;
        }
        //return false;   // Not found
    }

    function updateArray(array, item) {
        for (var i = 0; i < array.length; i++) {
            // This if statement depends on the format of your array
            if (array[i][0] == item[0] && array[i][1] == item[1]) {
                return true;   // Found it
            }
        }
        return false;   // Not found
    }

    function findArrayElementByValue(array, value) {
        return array.find((element) => {
            return element.key === value;
        });
    }    

    in return:
    <div className="whiteText centerAlign">
                                <div className={user.uid ? "hidden" : "logIn"}>
                                    <table className="userLoginRegister">
                                        <tbody>
                                            <tr>
                                                <th>Login</th></tr>
                                            <tr><td><input name="RegisterEmail" placeholder="Email..." value={userEmail} onChange={(event) => { setUserEmail(event.target.value); }} /></td></tr>
                                            <tr><td><input name="RegisterPassword" placeholder="Password..." value={userPassword} onChange={(event) => { setUserPassword(event.target.value); }} /></td></tr>
                                            <tr><td><Button className="loginButton" variant="primary" size="md" onClick={login}>Login</Button><Button className="registerLink" variant="link" size="md" onClick={register}>Register</Button></td></tr>
                                            <tr><td><Button className="resetPassLink" variant="link" onClick={resetPass}>reset password</Button></td></tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className={user.uid ? "logOut" : "hidden"}>
                                    <h4> Logged in as: {user?.email}</h4>
                                    <button onClick={logout}>Log Out</button>
                                </div>
                            </div>
    */
};
export default CurrentWeek;
